import XhsAccountList from "@/components/XhsAccountList.vue";
import XhsNoteList from "@/components/XhsNoteList.vue";
import api from "@/api";
export default {
  name: "XhsListView",
  components: {
    XhsNoteList,
    XhsAccountList
  },
  data() {
    return {
      tab: '0',
      permissions: []
    };
  },
  methods: {
    init() {
      api.getUserInfo().then(ret => {
        this.permissions = ret.permissions;
      });
    }
  },
  mounted() {
    this.init();
  }
};